import { FC, memo } from 'react';

import { useAvatarWithRandomColor } from './hooks/useAvatarWithRandomColor';
import { AvatarProps } from './types/AvatarProps';
import { Avatar } from './Avatar';

/**
 * Mimics the Chakra V1/V2 Avatar component
 * Fallback (originally "name") generates a random colour scheme with some mixed
 * results. Future state is to use the regular Avatar component this inherits,
 * along with custom user tools for selecting colours and images.
 */
const AvatarWithRandomColorComponent: FC<AvatarProps> = ({
  fallback,
  ...props
}) => {
  const { bg, color } = useAvatarWithRandomColor(fallback);

  return <Avatar fallback={fallback} {...props} bg={bg} color={color} />;
};

export const AvatarWithRandomColor = memo(AvatarWithRandomColorComponent);
